<template>
  <el-scrollbar class="ruijie-menu">
    <el-menu
      :collapse="Collapse"
      :default-active="activename"
      :collapse-transition="false"
    >
      <el-submenu
        v-for="subitem in menudata1"
        :index="subitem.id"
        :key="subitem.id"
      >
        <template slot="title">
          <!--<i :class="subitem.icon" v-if="subitem.icon" style="font-size: 18px"></i>-->
          <span>{{ subitem.title }}</span>
          <!--<span v-if="$i18n.locale=='en'">{{subitem.entitle}}</span>-->
        </template>
        <router-link
          :to="{ path: item.path }"
          v-for="item in subitem.children"
          :key="item.id"
        >
          <el-menu-item :index="item.id">
            <span>{{ item.title }}</span>
            <!--<span v-if="$i18n.locale=='en'">{{item.entitle}}</span>-->
          </el-menu-item>
        </router-link>
      </el-submenu>
    </el-menu>
    <div style="margin-top: 20px;margin-left: 20px;" v-if="false">
      <a href="http://ppso.ruijienetworks.com/QuotationSystem/QuotationSystem"
        >Ruijie Quotations</a
      >
    </div>
  </el-scrollbar>
</template>
<script type="text/ecmascript-6">
import * as Menulist from "../../router"
import Mdata from "../../utils/menuData"
import {mapState} from "vuex"
import API from "../../api"
import eventBus from "../../utils/eventBus"

export default {
  data() {
    return {
      menudata: Mdata,
      menudata1: [],
    }
  },
  computed: {
    ...mapState({
      Collapse: state => state.isCollapse
    }),
    activename() {
      let name = "";
      if (this.$route.query.aid) {
        name = this.$route.query.aid
      }

      return name;
    },
  },
  methods: {
    toggle() {
      //this.$store.dispatch('toggleMenu');
    },
    init() {
      API.getmenu().then((res) => {
        let json = res.data;
        if (json.status === "200") {
          this.menudata1 = json.data
        }
      }).catch(() => {
      });
    },
  },
  mounted() {
    this.init();
    eventBus.$on("reloadMenu", () => {
      this.init();
    })
  },
  destroyed() {
    eventBus.$off("reloadMenu")
  },
}
</script>
<style scoped>
/deep/ .el-scrollbar {
  height: calc(100vh - 116px);
  position: relative;
  overflow-x: hidden;
}
/deep/ .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
<style rel="stylesheet/scss" lang="scss">
.my-menu .el-menu {
  background: #f4f4f4;
}

.el-menu-item {
  font-size: 15px;
}

.el-submenu__title:hover {
  background-color: #f7f7f7;
}

.el-submenu__title {
  font-size: 15px;
}

.el-menu-item:focus,
.el-menu-item:hover {
  outline: 0;
  background-color: #fce8ec;
}

.is-active .el-submenu__title:before,
.el-menu-item.is-active.nochild:before {
  content: " ";
  position: absolute;
  left: 0px;
  width: 4px;
  height: 56px;
  background: #dd1d40;
}

.el-menu-item.is-active {
  background-color: #fce8ec;
  color: #fd5a00;
}

.el-menu {
  border-right: none;
}

.el-menu-item i {
  font-size: 18px;
  margin-right: 6px;
}

.el-menu-item.is-active.nochild {
  background-color: #fff;
  color: #303133;
}

.el-menu-item.nochild:focus,
.el-menu-item.nochild:hover {
  background-color: #fff;
  color: #303133;
}

.el-menu-item.is-active i {
  color: #909399;
}

.el-submenu__icon-arrow {
  margin-top: -4px;
}

.menutop {
  height: 80px;
  line-height: 80px;
  padding-left: 20px;
  font-size: 17px;
  border-bottom: 1px solid #ebebeb;
  position: relative;

  .iconfont {
    position: absolute;
    right: 7px;
    padding: 0 20px;
    color: #dd1d40;
    cursor: pointer;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Menu.vue